// extracted by mini-css-extract-plugin
export var auto = "_3c-1";
export var spinner = "_3c-0";